import Page from 'src/components/molecules/page';
import { Container } from '@mui/material';
import { FC } from 'react';

import { CustomerReservationCancelDone } from 'src/components/organisms/customer-reservation/cancel-done';

export const CustomerReservationCancelDonePage: FC = () => {
  /* 定数宣言 */
  const title = '予約キャンセル完了';

  return (
    <Page title={title}>
      <Container maxWidth={false}>
        <CustomerReservationCancelDone />
      </Container>
    </Page>
  );
};
